/*
 * @Descripttion: 
 * @version: 
 * @Author: mrh
 * @Date: 2022-10-21 15:00:05
 * @LastEditors: mrh
 * @LastEditTime: 2022-11-02 17:04:04
 */
import Vue from 'vue'
import axios from "axios"

export function expertGetBindingCardList(params) {
    return axios.post("/v50/expert/pingan/getBindingCardList", params).then((res) => res.data);
}

// 500 解绑银行卡公共接口（王冬冬）
export function expertDelCard(params) {
    return axios.post("/v50/expert/pingan/delCard", params).then((res) => res.data);
}

// 500 绑卡1-获取银行代码(王冬冬)
export function expertGetBindingBankClsCodeList(params) {
    return axios.post("/v50/expert/pingan/getBindingBankClsCodeList", params).then((res) => res.data);
}

// 500 绑卡2-获取省份列表(王冬冬)
export function expertGetBindingProvinceList(params) {
    return axios.post("/v50/expert/pingan/getBindingProvinceList", params).then((res) => res.data);
}

// 500 绑卡3/4-获取市、区(市)、县列表(王冬冬)
export function expertGetBindingCityList(params) {
    return axios.post("/v50/expert/pingan/getBindingCityList", params).then((res) => res.data);
}

// 500 绑卡5-获取银行网点列表(王冬冬)
export function expertGetBindingBankInfoList(params) {
    return axios.post("/v50/expert/pingan/getBindingBankInfoList", params).then((res) => res.data);
}

// 500 社区店长 获取平安绑卡验证码（王冬冬）
export function expertGetBindingSmsCode(params) {
    return axios.post("/v50/expert/pingan/getBindingSmsCode", params).then((res) => res.data);
}

// 500 社区店长 绑卡鉴权--》回填短信验证码（王冬冬）
export function expertPutBindingSmsCode(params) {
    return axios.post("/v50/expert/pingan/putBindingSmsCode", params).then((res) => res.data);
}

// 500 获取用户平安操作错误信息公共接口（王冬冬）
export function expertGetOperateFailMsg(params) {
    return axios.post("/v50/expert/pingan/getOperateFailMsg", params).then((res) => res.data);
}

// 500 获取最小提现值和最大提现值（王冬冬）
export function expertGetSystemWithdrawValue(params) {
    return axios.post("/v50/expert/pingan/getSystemWithdrawValue", params).then((res) => res.data);
}

// 300 社区店长 提现--》获取验证码（王冬冬）
export function expertGetWithdrawSmsCode(params) {
    return axios.post("/v50/expert/getWithdrawSmsCode", params).then((res) => res.data);
}
// 300 社区店长 提现--》回填验证码（王冬冬）
export function expertPutWithdrawSmsCode(params) {
    return axios.post("/v50/expert/putWithdrawSmsCode", params).then((res) => res.data);
}
// 300 社区店长 提现--》回填验证码（王冬冬）
export function getExpertInfo(params) {
    return axios.post("/v50/expert/getExpertInfo", params).then((res) => res.data);
}

// 600（协议）获取行家教程（王冬冬）
export function getRuleContent(params) {
    return axios.post("/v50/expert/common/getRuleContent", params).then((res) => res.data);
}


// /v50/expert/pingan/getSystemWithdrawValue  /v50/expert/getExpertInfo

// 600 数据中心(王冬冬)
export function getExpertDataCenterApi(params) {
    return axios.post("/v50/expert/common/getRuleContent", params).then((res) => res.data);
}

// 700 获取验证码短信（王冬冬）
export function getVCode(params) {
    return axios.post("/v50/expert/common/getVCode", params).then((res) => res.data);
}

// 700 行家注销(王冬冬)
export function expertDeregister(params) {
    return axios.post("/v50/expert/700/deregister", params).then((res) => res.data);
}

// 500获取短信加密密钥（王冬冬）
export function getMCipher(params) {
    return axios.post("/v50/expert/common/getMCipher", params).then((res) => res.data);
}

// 720用户身份信息、用户基本信息（王冬冬）
export function getUserInfo(params) {
    return axios.post("/v50/expert/720/getUserInfo", params).then((res) => res.data);
}

// 740 圈子首页-公告,类型(杨斯匀)
export function getTypeAndsw(params) {
    return axios.post("/v50/expert/740/circle/index/typeAndsw", params).then((res) => res.data);
}